import { RefreshCw } from 'lucide-react'
import { useState } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import { Button, StatusMessage, useReloadBlocked } from '@krp/ui-kit'

/**
 * Ошибка загрузки куска сборки: браузер называет её по-разному (Chrome, Firefox, Safari). Это не поломка кода, а
 * вкладка на старой сборке — после выкатки файлы с прежними хэшами на сервере уже заменены новыми.
 */
const STALE_CHUNK = /dynamically imported module|Importing a module script failed|Unable to preload CSS/i

/** Текст ошибки маршрута — дословно, как пришёл (CLAUDE.md: ошибки показываются целиком). */
function routeErrorText(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`.trim()
  if (error instanceof Error) return error.message
  return typeof error === 'string' ? error : 'Неизвестная ошибка'
}

/** Экран ошибки окна вместо стандартного экрана маршрутизатора; оболочка (меню, связь, плашки) остаётся на месте. */
export function RouteError({ reload }: { reload: () => Promise<void> }) {
  const error = useRouteError()
  const blocked = useReloadBlocked()
  const [busy, setBusy] = useState(false)
  const text = routeErrorText(error)
  const stale = STALE_CHUNK.test(text)

  return (
    <StatusMessage
      kind="error"
      title={stale ? 'Вышла новая версия — эта вкладка на старой' : 'Окно не открылось из-за ошибки'}
      text={stale ? 'Часть приложения не загрузилась: на сервере уже новая сборка. Обновите страницу.' : undefined}
      meta={text}
      action={
        <Button
          variant="primary"
          data-size="sm"
          busy={busy}
          disabled={blocked}
          disabledReason={blocked ? 'Открыт чек или идёт оплата: обновление после закрытия чека' : null}
          icon={<RefreshCw size={14} aria-hidden="true" />}
          onClick={() => {
            setBusy(true)
            void reload().finally(() => setBusy(false))
          }}
          actionId="shell.update"
        >
          Обновить
        </Button>
      }
    />
  )
}
